function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: "24",
  height: "24",
  rx: "3.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 7c3.1 0 7 3.05 7 4.5 0 1.45-3.897 4.5-7 4.5s-7-3.05-7-4.5C5 10.05 8.9 7 12 7zm0 1.125c-2.968 0-5.52 2.746-5.81 3.375.59 1.097 3.225 3.375 5.81 3.375 2.585 0 4.908-2.022 5.809-3.375-.232-.563-2.84-3.375-5.809-3.375zm0 1.688c.966 0 1.75.755 1.75 1.687s-.784 1.688-1.75 1.688-1.75-.756-1.75-1.688c0-.932.784-1.688 1.75-1.688zm0 1.124a.573.573 0 00-.583.563c0 .31.26.563.583.563a.573.573 0 00.583-.563.573.573 0 00-.583-.563z",
  fill: "#54585D"
}))));